export function sharedCookieDomain(hostname: string): string | undefined {
  return hostname === 'hocnhe.com' || hostname.endsWith('.hocnhe.com') ? '.hocnhe.com' : undefined
}
